import React from "react";
import { Link } from "react-router-dom";
import { isTokenExpired } from "../../utils/persist";
import { pushDatatoAdobeLayer } from '../../analytics/pmiAdobeLog';
import { getAdobeAnalyticsEventObject, getAdobeAnalyticsCustomLinkObj } from '../../analytics/analyticsObject';
const Footer = () => {
  const isAuthenticated = !isTokenExpired();

  const adobeCustomLog = (path, url) => {
    let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
    let customLObj = getAdobeAnalyticsCustomLinkObj(path, "footers", url);
    pushDatatoAdobeLayer({
      customLinkData: { ...customEventObj, ...customLObj },
      pageData: false,
      adobePushTracking: false,
    });
  }
  return (
    <div className="flex bg-white border-t border-grey-200 w-full items-center py-4 px-5 md:px-20" adoberegion='footers'>
      <div className="container mx-auto">
        <div className="flex items-center">
          <Link to={isAuthenticated ? "/home" : "/"}>
            <img
              style={{ width: "16rem", cursor: "pointer" }}
              src="/images/pmi_logo_v5.png"
              alt="PMI Logo"
            />
          </Link>
          <div className="sm:ml-8 sm:text-base ml-4 text-sm">
            <a
              href="https://www.pmi.org/privacy"
              className="text-gray-700 hover:text-purple-700 sm:mr-8 mr-4 cursor-pointer transition duration-300 ease-in-out"
              target="_blank"
              onClick={() => adobeCustomLog('privacy policy', 'https://www.pmi.org/privacy')}
            >
              Privacy
            </a>
            <Link
              to="/terms"
              className="text-gray-700 hover:text-purple-700 whitespace-no-wrap cursor-pointer transition duration-300 ease-in-out"
              onClick={() => adobeCustomLog('terms & conditions', '/terms')}
            >
              Terms of Use
            </Link>
          </div>
        </div>
        <div className="ml-2 mt-2 text-sm">
          © {new Date().getFullYear()} Project Management Institute, Inc.
        </div>
      </div>
    </div>
  );
};

export default Footer;
